// Client-side mirror of functions/gameData.js's OASIS_CATALOG -- static,
// never changes, safe to duplicate rather than share across the
// client/server boundary.
export const OASIS_CATALOG = {
  1: { value: 2, isPortal: true },
  2: { value: -1, isPortal: false },
  3: { value: -1, isPortal: false },
  4: { value: -2, isPortal: false },
  5: { value: 3, isPortal: false },
  6: { value: 3, isPortal: false },
  7: { value: 3, isPortal: false },
  8: { value: 3, isPortal: true },
  9: { value: 3, isPortal: true },
  10: { value: 1, isPortal: false },
  11: { value: 1, isPortal: false },
  12: { value: 2, isPortal: true },
  13: { value: 2, isPortal: false },
  14: { value: 2, isPortal: false },
  15: { value: 4, isPortal: false },
};

export const ALL_OASIS_IDS = Object.keys(OASIS_CATALOG).map(Number);

export const ANIMAL_COUNTS = {
  scorpion: 2,
  jerboa: 4,
  jackal: 6,
  camel: 6,
  oryx: 6,
  elephant: 2,
  chameleon: 2,
};

export const ANIMAL_STRENGTH = {
  scorpion: 0,
  jerboa: 1,
  jackal: 2,
  camel: 3,
  oryx: 4,
  elephant: 5,
};

export const ANIMAL_LABEL = {
  scorpion: 'Scorpion',
  jerboa: 'Jerboa',
  jackal: 'Jackal',
  camel: 'Camel',
  oryx: 'Oryx',
  elephant: 'Elephant',
  chameleon: 'Chameleon',
};
